import type { MouseEvent, ReactNode } from 'react';

import {
  AnchoredAlert,
  AnchoredAlertClose,
  AnchoredAlertMessage,
  type AnchoredAlertVariant,
} from '@vs-shop/ui/anchoredAlert';

import { getMemoizedIntlShapeWithDefaultLocale } from '../../../../utils/intl';

type Props = {
  message: ReactNode;
  onClose: (event: MouseEvent<HTMLButtonElement>) => void;
  variant: AnchoredAlertVariant;
};

/**
 * rcprofi's binding of the anchored alert to the add-to-cart controls that
 * raise one: the coupon mark on a product card, and the add-to-cart button a
 * CMS content block renders.
 *
 * The copy is what stays here — the message its caller computed, and the label
 * the dismiss control is announced by.
 */
export default function ProductAddToCartErrorPopupBottom({ message, onClose, variant }: Props) {
  const intl = getMemoizedIntlShapeWithDefaultLocale();

  return (
    <AnchoredAlert variant={variant}>
      <AnchoredAlertMessage>{message}</AnchoredAlertMessage>
      <AnchoredAlertClose
        onClick={onClose}
        aria-label={intl.formatMessage({
          id: 'component.server.product.card.productAddToCartErrorPopupBottom.close',
          defaultMessage: 'Zavřít',
        })}
      />
    </AnchoredAlert>
  );
}
